<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      router-link.btn.btn-default(v-if="devOrDemoEnvironment" :to="{name: 'rollCreate', params: {id: orderId}}")
        i.fa.fa-plus
        span.ml5 New Roll

    .row.order-rolls
      .col-sm-4
        .panel.panel-default
          .panel-heading.panel-title Rolls Codes Statistics
          .panel-body(v-if="rollStats")
            .container-fluid
              .row
                label.col-sm-6 Number of codes
                .col-sm-6 {{rollStats.totalCodes}}
              .row
                label.col-sm-6 Unactivated Codes
                .col-sm-6 {{rollStats.unactivatedCodes}}
              .row
                label.col-sm-6 Activated Codes
                .col-sm-6 {{activateCodes}}
      .col-sm-8
        DataGrid(ref="grid" :fetch="fetchData" url-page-param="page")
          tr(slot="thead")
            th Id
            th Description
            th First Code
            th Last Code
            th First Unactivated Code
            th Activated Codes
          tr.clickable(v-for="r in rolls" @click="goToRoll(r.id)")
            td {{r.id}}
            td {{r.description}}
            td
              span(:title="r.first.code" v-if="r.calibrated && r.first") {{r.first.codeIndex}}
            td
              span(:title="r.last.code" v-if="r.calibrated && r.last") {{r.last.codeIndex}}
            td
              span(:title="r.firstUnactivated.code" v-if="r.calibrated && r.firstUnactivated") {{r.firstUnactivated.codeIndex}}
              .text-muted(colspan="3" v-else-if="!r.calibrated") not calibrated
              em.text-muted(v-else) Fully activated
            td {{activatedCodes(r.size, r.unactivated)}} of {{r.size}}
</template>

<script>
import Core from '@/service/apis/Core'
import DataGrid from '@/components/ssp/DataGrid'
import Security from '@/service/apis/Security'

export default {
  data: () => ({
    rolls: null,
    rollStats: null,
    devOrDemoEnvironment: false,
    errorMsg: null
  }),
  created() {
    Core.getRollStats(this.orderId)
      .then((resp) => {
        this.rollStats = resp.data
      })
      .catch((e) => {
        this.$emit('error', e)
      })

    Security.userInfo().then((r) => {
      const env = r.data.title.toLowerCase()
      if (env && (env === 'dev' || env === 'demo')) {
        this.devOrDemoEnvironment = true
      }
    })
  },
  methods: {
    activatedCodes(size, unactivated) {
      return parseInt(size - unactivated, 10)
    },
    fetchData(page) {
      const req = page.pageRequest()
      return Core.listOrderRolls(this.orderId, req)
        .then((resp) => {
          this.rolls = resp.data.content
          return resp.data.totalElements
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    goToRoll(rollId) {
      this.$router.push({ name: 'roll', params: { orderId: this.orderId, rollId } })
    }
  },
  computed: {
    orderId() {
      return parseInt(this.$route.params.id, 10)
    },
    activateCodes() {
      return this.rollStats ? this.rollStats.totalCodes - this.rollStats.unactivatedCodes : 0
    }
  },
  components: {
    DataGrid
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/roll/Rolls.vue